import { Component, OnInit, OnChanges } from '@angular/core';
import { TestService } from '../_services/test.service';
import * as d3 from 'd3';
import { StudentService } from '../_services/student.service';
import { fromEvent, Subscription } from 'rxjs';
import { Student } from '../student-list/student';
import { OrgService } from '../_services/org.service';
import { ResponsiveService } from '../_services/responsive.service';
import { TimeGraph } from '../graphs/timegraph';
import { debounceTime } from 'rxjs/operators';
import { PhaseService } from '../_services/phase.service';
import { LoaderService } from '../loader/loader.service';
@Component({
	selector: 'app-time-graph',
	templateUrl: './time-graph.component.html',
	//CSS is added from styles.css, not here because angular does not load css after D3 draws the graph
})
export class TimeGraphComponent implements OnInit {
	private graphData;
	private svg;
	media: any;
	activePhase: any;
	subscriptions: Subscription[] = [];

	public activeStudent: Student;
	public selectedClassroom: any;
	public selectedSchool: any;
	constructor(
		private StudentService: StudentService,
		private testService: TestService,
		public orgService: OrgService,
		public responsiveService: ResponsiveService,
		public phaseService: PhaseService,
		public LoaderService: LoaderService,
	) {}

	ngOnInit(): void {
		this.subscriptions.push(
			this.phaseService.selectedPhase$.subscribe((data: any) => {
				this.activePhase = data;
			}),
		);

		this.subscriptions.push(
			this.orgService.selectedSchool$.subscribe((data: any) => {
				this.selectedSchool = data;
			}),
		);
		this.subscriptions.push(
			this.orgService.selectedClassroom$.subscribe((data: any) => {
				this.selectedClassroom = data;
				this.subscriptions.push(
					this.StudentService.selectedStudent$.subscribe(
						(studentData: Student) => {
							this.activeStudent = studentData;
							if (studentData) {
								this.activePhase = localStorage.getItem('activePhase')
									? JSON.parse(localStorage.getItem('activePhase'))
									: this.activeStudent.phases.slice(-1)[0];
								this.testService
									.getStudentTimeGraph(
										studentData.id,
										data.id,
										this.activeStudent.assessmentBookId,
										this.activeStudent.assessmentTemplateId,
									)
									.subscribe(
										(data) => {
											this.testService.setStudentTimeGraphData(data);
										},
										(error) => {
											console.log(error);
										},
									);
							}
						},
					),
				);
			}),
		);

		this.subscriptions.push(
			this.testService.timeGraph.subscribe((graphData: TimeGraph) => {
				//any graph data change will cause a redraw.
				this.graphData = graphData;
				if (this.graphData) {
					this.drawTimeProgressGraph();
				}
			}),
		);

		//using formevent resize
		this.media = fromEvent(window, 'resize')
			.pipe(debounceTime(250))
			.subscribe(
				(event) => {
					this.drawTimeProgressGraph();
				},
				(error) => {
					console.log(error);
				},
			);
	}

	private drawTimeProgressGraph() {
		console.log('draw graph called');
		let divId = this.graphData.divId;
		if (document.getElementById(divId)) {
			document.getElementById(divId).innerHTML = '';
		}
		let data = this.graphData.data;
		let testScale = this.graphData.testScale;
		let fillerDates = this.graphData.fillerDates;
		let allToolTips = document.getElementsByClassName('.tool-tip');
		Array.prototype.slice.call(allToolTips).forEach(function (eachToolTip) {
			eachToolTip.value = '';
		});
		var width = 0;
		var height = 0;
		var widthUnit = 0; //also margin unit
		var heightUnit = 0;
		var leftMargin = 0;
		var rightMargin = 0;
		var topMargin = 0;
		var bottomMargin = 0;
		var fontSize = 0;

		function calculateGraphDimensions(divId) {
			if (document.getElementById(divId)) {
				width = document.getElementById(divId).offsetWidth;
			}
			height = width * 0.6;

			widthUnit = width / 15; //also margin unit
			heightUnit = height / 15;

			leftMargin = 0 + widthUnit + widthUnit / 4;
			rightMargin = width - (widthUnit + widthUnit / 4);

			topMargin = 0 + widthUnit + widthUnit / 4;
			bottomMargin = height - (widthUnit + widthUnit / 4);

			fontSize = widthUnit / 3;
		}

		calculateGraphDimensions(divId);

		var tooltipDiv = d3.select('body').append('div').attr('class', 'tooltip');
		this.svg = d3
			.select('#' + divId)
			.append('svg')
			.attr('width', width)
			.attr('height', height)
			.attr('viewBox', `0 0 ${width} ${height}`);

		var xScale = d3
			.scaleLinear()
			.range([leftMargin, rightMargin])
			.domain([0, testScale.xLimit]);
		var yScale = d3
			.scaleLinear()
			.range([bottomMargin, topMargin])
			.domain([0, testScale.yLimit]);

		var xAxis = d3.axisBottom(xScale).ticks(10);
		var yAxis = d3.axisLeft(yScale).ticks(10);

		var tickFontSize = fontSize;
		if (tickFontSize > 16) {
			tickFontSize = 16;
		}

		this.svg
			.append('g')
			.style('font-size', tickFontSize)
			.attr('transform', 'translate(0,' + bottomMargin + ')')
			.call(xAxis);

		this.svg
			.append('g')
			.style('font-size', tickFontSize)
			.attr('transform', 'translate(' + leftMargin + ', 0)')
			.call(yAxis);

		var xyPoints = new Array();
		var testPoints = [];
		var indexOfTest = 0;
		for (var eachDate in data) {
			var eachXY = new Map();
			eachXY.set('y', data[eachDate]);
			eachXY.set('x', indexOfTest);
			var testPoint: { [key: string]: any } = {};
			if (fillerDates.indexOf(eachDate) > -1) {
				//no test happened this day
				testPoint.y = 0;
			} else {
				//test happened this day
				testPoint.y = data[eachDate];
				testPoint.date = eachDate;
				testPoint.x = indexOfTest;
				xyPoints.push(eachXY);
			}
			indexOfTest += 1;
			testPoints.push(testPoint);
		}
		if (testScale.divisions > 0) {
			for (var i = 0; i < testScale.divisions; i++) {
				let oneYUnit = (bottomMargin - topMargin) / testScale.yLimit;
				let heightMultiplier = testScale.divisionsY[i];
				this.svg
					.append('rect')
					.attr('x', leftMargin)
					.attr('y', bottomMargin - oneYUnit * heightMultiplier)
					.attr('width', rightMargin - leftMargin)
					.attr('height', oneYUnit * heightMultiplier)
					.attr('fill', testScale.divisionColors[i]);
			}
		}

		var line = d3
			.line<Map<any, any>>()
			.x(function (d) {
				return xScale(d.get('x'));
			})
			.y(function (d) {
				return yScale(d.get('y'));
			})
			.curve(d3.curveBasis);

		this.svg
			.append('path')
			.datum(xyPoints)
			.attr('class', 'progressLine')
			.attr('d', line);

		this.svg
			.selectAll('.testPoint')
			.data(testPoints)
			.enter()
			.append('circle')
			.attr('cx', function (d, i) {
				return xScale(i);
			})
			.attr('cy', function (d) {
				return yScale(d.y);
			})
			.filter(function (d) {
				return d.y > 0;
			})
			.attr('class', 'testPoint')
			.attr('r', 5)
			.on('mouseover', function (d, i) {
				tooltipDiv
					.style('opacity', 1)
					.style('z-index', 2)
					.html(
						'<table class="tooltipTable"><tr><td>' +
							i.date +
							'</td></tr><tr><td><div class="text-center badge badge-secondary">' +
							i.y +
							'</div></td></tr></table>',
					)
					.style('left', d.pageX + 20 + 'px')
					.style('top', d.pageY - 25 + 'px');
			})
			.on('mouseout', function (d, i) {
				tooltipDiv.style('opacity', 0).style('z-index', -2);
			});

		let labelFontSize = fontSize * 1.4;
		if (labelFontSize > 22) {
			labelFontSize = 22;
		}

		let bottomLabelX = leftMargin + (rightMargin - leftMargin) / 2;
		let bottomLabelY = bottomMargin + widthUnit;

		this.svg
			.append('text')
			.attr('x', bottomLabelX)
			.attr('y', bottomLabelY)
			.style('text-anchor', 'middle')
			.style('font-weight', 600)
			.style('font-size', labelFontSize)
			.text('Days');

		let leftLabelX = leftMargin - widthUnit / 1.25;
		let leftLabelY = topMargin + (bottomMargin - topMargin) / 2;

		this.svg
			.append('text')
			.attr('x', leftLabelX)
			.attr('y', leftLabelY)
			.attr('transform', 'rotate(-90, ' + leftLabelX + ', ' + leftLabelY + ' )')
			.style('text-anchor', 'middle')
			.style('font-weight', 600)
			.style('font-size', labelFontSize)
			.text('Score');

		this.svg
			.append('text')
			.attr('x', leftMargin)
			.attr('y', bottomMargin + widthUnit)
			.style('text-anchor', 'middle')
			.style('font-size', tickFontSize)
			.text(testScale.startDate);

		this.svg
			.append('text')
			.attr('x', rightMargin)
			.attr('y', bottomMargin + widthUnit)
			.style('text-anchor', 'middle')
			.style('font-size', tickFontSize)
			.text(testScale.endDate);

		var finalPoint = testPoints[testPoints.length - 1];
		if (!finalPoint) {
			return;
		}
		if (finalPoint.y == 100) {
			var symbolGenerator = d3.symbol().type(d3.symbolStar).size(200);
			var pathData = symbolGenerator();

			this.svg
				.append('g')
				.attr('class', 'starPoint')
				.attr(
					'transform',
					'translate(' +
						xScale(finalPoint.x) +
						' , ' +
						yScale(finalPoint.y) +
						')',
				);

			d3.select('.starPoint')
				.append('path')
				.attr('class', 'achieve-star')
				.attr('d', pathData);

			d3.select('.starPoint')
				.on('mouseover', function (d) {
					tooltipDiv
						.style('opacity', 1)
						.style('z-index', 2)
						.html(
							'<table class="tooltipTable"><tr><td>' +
								finalPoint.date +
								'</td></tr><tr><td><div class="text-center badge badge-secondary">' +
								finalPoint.y +
								'</div></td></tr></table>',
						)
						.style('left', d.pageX + 20 + 'px')
						.style('top', d.pageY - 25 + 'px');
				})
				.on('mouseout', function (d, i) {
					tooltipDiv.style('opacity', 0).style('z-index', -2);
				});
		}
	}

	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
}
